// Copyright 2016 Sorama B.V.

import { IParameterizedValueConverter2 } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";
import moment from "moment";

export class DurationToStringValueConverter implements IParameterizedValueConverter2<
    string,
    moment.Duration,
    number,
    string
> {
    public toView(value: moment.Duration, minimumDurationInMilliseconds: number, belowMinimumString: string): string {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null) {
            return null;
        }

        return value.asMilliseconds() < minimumDurationInMilliseconds ? belowMinimumString : value.humanize();
    }

    public fromView(value: string, minimalDurationInMilliseconds: number, belowMinimumString: string): moment.Duration {
        throw new NotSupportedError("DurationToStringValueConverter does not support fromView.");
    }
}
